import { getDateStringForPeriod } from 'View/schedule-generate/helper/getPeriodDay';

const addHostSchedule = ({ selectedHost, locationSchedules, onOpenToast, yearMonth, popupLocation, accounts, accountIndex, weekIndex, updateState, t }) => {
  const currentAccount = accounts[accountIndex];
  const { datas } = currentAccount;

  const isTheSameHost = locationSchedules.some((schedule) => schedule?.userId === selectedHost?.id);
  if (isTheSameHost) {
    onOpenToast({
      status: 'error',
      description: t('hostAlreadyHasSchedule', { hostName: selectedHost?.name }),
      duration: 3,
      alwaysShow: false,
    });
    return;
  }
  const dateString = getDateStringForPeriod(popupLocation[0], yearMonth);
  const newSubShiftStartTime = new Date(`${dateString} ${String(popupLocation[1]).padStart(2, '0')}:00:00`);
  const newSubShiftEndTime = new Date(newSubShiftStartTime.getTime() + 7200000);
  const newSchedule = {
    userId: selectedHost?.id,
    name: selectedHost?.name,
    isPregnancy: selectedHost?.isPregnancy,
    subShiftStartTime: newSubShiftStartTime,
    subShiftEndTime: newSubShiftEndTime,
    location: popupLocation,
    accountId: currentAccount.accountId,
    studioId: currentAccount.studioId,
    bgColor: selectedHost?.bgColor || 'var(--color-primary10)',
  };
  datas[weekIndex].schedules.push(newSchedule);

  accounts[accountIndex].datas = datas;
  updateState({ accounts });
};

export default addHostSchedule;
